import { RootPage } from '../page';
import $api from '../../api';
import Pager from '../../components/pager';
import CollectedFeedbackView from './inbox-views/collected-feedback';
import AdoptionMeterView from './inbox-views/adoption-meter';

class FeedbackInboxView extends RootPage {
    constructor() {
        super();

        Pager();
        CollectedFeedbackView(this);
        AdoptionMeterView(this);

        this.selectedInbox = ko.observable('feedback');
    }

    onInit() {

    }

    selectInbox(inbox) {
        this.selectedInbox(inbox);
    }
}

export default FeedbackInboxView;